import { useEffect } from "react";
import Lenis from "lenis";

// Smooth momentum scrolling + programmatic scroll-to for anchor nav.
export default function useLenis(enabled = true) {
  useEffect(() => {
    if (!enabled) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    // Expose a global scroll helper for nav links.
    window.__lenisScrollTo = (target) => {
      const el = document.querySelector(target);
      if (el) lenis.scrollTo(el, { offset: -80, duration: 1.3 });
    };

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      delete window.__lenisScrollTo;
    };
  }, [enabled]);
}
